import { Component, OnInit } from '@angular/core';
import { AbstractBaseComponent } from '@shared/abstract-base/abstract-base.component';
import { RadioChange } from '@frk/eds-components/lib/amo/atoms/radio/radio-change.class';

import { Logger } from '@utils/logger';
import {
  GroupItems,
  SubscriptionsParams,
} from '@marketing/subscriptions-manage/subscription-manage.interface';

/**
 * Logger
 */
const logger = Logger.getLogger('SubscriptionsManageComponent');

@Component({
  selector: 'ft-subscriptions-manage',
  templateUrl: './subscriptions-manage.component.html',
  styleUrls: ['./subscriptions-manage.component.scss'],
})
export class SubscriptionsManageComponent
  extends AbstractBaseComponent
  implements OnInit {
  public subscriptionsParams: SubscriptionsParams;
  public radioItems: GroupItems[] = [
    {
      id: 'monthly',
    },
    {
      id: 'quarterly',
    },
    {
      id: 'as-available',
    },
  ];

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.subscriptionsParams = this.component.getParameters();
    logger.debug('Component initialised');
  }

  public onRadioChange($event: RadioChange) {
    logger.debug('Change radio:', $event);
  }
}
